import NL_Code from "../assets/NL_Code.svg";
import NL_Group from "../assets/NL_Group.svg";
import NL_User from "../assets/NL_User.svg";

export const getNumberOfUsers = (data) => {
  let number = 0;
  if (data.groupes.length > 0) {
    data.groupes.forEach((x) => (number += x.groupMembers.length));
  } else if (data.users.length > 0) {
    number = data.users.length;
  } else if (data.codeEtapes.length > 0) {
    number = data.codeEtapes.length;
  }
  return number;
};

export const getListOfUsers = (data) => {
  let users = [];
  if (data.groupes.length > 0) {
    data.groupes.forEach((x) => {
      if (x.groupMembers.length > 0) {
        x.groupMembers.forEach((member) => {
          users.push(member.user);
        });
      }
    });
  } else if (data.users.length > 0) {
    users = data.users;
  }
  return users;
};

export const getListOfContacts = (data) => {
  let contacts = [];
  if (data.groupes.length > 0) {
    data.groupes.forEach((x) => {
      contacts.push({
        id: x.id,
        label: x.label,
        type: "group",
      });
    });
  } else if (data.users.length > 0) {
    data.users.forEach((x) =>
      contacts.push({
        id: x.id,
        label: x.firstname + " " + x.surname,
        type: "user",
      })
    );
  } else if (data.codeEtapes.length > 0) {
    data.codeEtapes.forEach((x) =>
      contacts.push({
        id: x.id,
        label: x.codeEtape,
        type: "code",
      })
    );
  }
  return contacts;
};

export const fillListOfContact = (listOfContact) => {
  if (!listOfContact || listOfContact.length === 0) return null;
  if (listOfContact[0].type === "group") {
    return {
      groupes: listOfContact.map((group) => {
        return `/api/groups/${group.id}`;
      }),
    };
  }
  if (listOfContact[0].type === "user") {
    return {
      users: listOfContact.map((user) => {
        return `/api/users/${user.id}`;
      }),
    };
  }
  if (listOfContact[0].type === "code") {
    return {
      codeEtapes: listOfContact.map((code) => {
        return `/api/education_etapes/${code.id}`;
      }),
    };
  }
};

export const getCustomIcon = (listOfContact) => {
  if (listOfContact.groupes.length > 0) {
    return NL_Group;
  }
  if (listOfContact.users.length > 0) {
    return NL_User;
  }
  if (listOfContact.codeEtapes.length > 0) {
    return NL_Code;
  }
  return null;
};

export const getCustomIconBis = (listOfContact) => {
  if (!listOfContact || listOfContact.length === 0) return null;
  if (listOfContact[0].type === "group") {
    return NL_Group;
  }
  if (listOfContact[0].type === "user") {
    return NL_User;
  }
  if (listOfContact[0].type === "code") {
    return NL_Code;
  }
};
